// gym/GymRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Gym from './Gym';
import GymClients from './GymClients';
import GymMemberships from './GymMemberships';
import GymPayments from './GymPayments';
import GymCoaches from './GymCoaches';
import GymCoachAssignments from './GymCoachAssignments';
import GymSchedule from './GymSchedule';
import GymAttendance from './GymAttendance';
import GymShopProducts from './GymShopProducts';
import GymShopSales from './GymShopSales';
import GymSettings from './GymSettings';

const GymRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Gym />} />
      <Route path="clients" element={<GymClients />} />
      <Route path="abonnements" element={<GymMemberships />} />
      <Route path="paiements" element={<GymPayments />} />
      <Route path="coaches" element={<GymCoaches />} />
      <Route path="coach-assignments'" element={<GymCoachAssignments />} />
      <Route path="emploi-du-temps" element={<GymSchedule />} />
      <Route path="presences" element={<GymAttendance />} />
      <Route path="shop-products" element={<GymShopProducts />} />
      <Route path="boutique/ventes" element={<GymShopSales />} />
      <Route path="settings" element={<GymSettings />} />
    </Routes>
  );
};

export default GymRoutes;